import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'
import formatDate from '@/utils/formatDate'
import isObject from '../../utils/object'

export default {
  namespaced: true,
  actions: {
    async createOffer(context, { offer, banner, customer, attachments }) {
      const blob = new Blob(
        [
          JSON.stringify({
            name: offer.name,
            content: offer.content,
            type: offer.type,
            status: offer.status,
            condition: offer.condition,
            clientEnabled: offer.clientEnabled,
            validSince: formatDate(offer.validSince),
            validUntil: formatDate(offer.validUntil),
          }),
        ],
        {
          type: 'application/json',
        }
      )

      const formData = new FormData()
      formData.append('offer', blob)

      if (banner) {
        formData.append('banner', banner[0])
      }

      if (customer) {
        formData.append('customer', customer[0])
      }

      if (attachments) {
        attachments.forEach((e) => {
          formData.append('attachments', e)
        })
      }

      const response = await http.post(`personalized-offer/`, formData)

      return response
    },
    async updateOffer(context, { offer, banner, customer, attachments }) {
      const blob = new Blob(
        [
          JSON.stringify({
            name: offer.name,
            content: offer.content,
            type: isObject(offer.type) ? offer.type.name : offer.type,
            status: isObject(offer.status) ? offer.status.name : offer.status,
            condition: isObject(offer.condition) ? offer.condition.name : offer.condition,
            clientEnabled: offer.clientEnabled,
            validSince: formatDate(offer.validSince),
            validUntil: formatDate(offer.validUntil),
          }),
        ],
        {
          type: 'application/json',
        }
      )

      const formData = new FormData()
      formData.append('offer', blob)

      if (banner) {
        formData.append('banner', banner[0])
      }

      if (customer) {
        formData.append('customer', customer[0])
      }

      if (attachments) {
        attachments.forEach((e) => {
          formData.append('attachments', e)
        })
      }

      const response = await http.put(`personalized-offer/${offer.id}`, formData)

      return response
    },
    async getOffer(context, id) {
      const response = await http.get(`personalized-offer/${id}`)

      return response
    },
    async deleteOffer(context, id) {
      const response = await http.delete(`personalized-offer/${id}`)

      return response
    },
    async searchOffers(context, params) {
      const response = await http.get(`personalized-offer/${requestUrlFunction(params)}`)

      return response
    },
    async searchOfferCustomers(context, { id, params }) {
      const response = await http.get(
        `personalized-offer/${id}/customer/${requestUrlFunction(params)}`
      )

      return response
    },
  },
}
